import { Link } from 'react-router-dom';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { Button } from '@/components/ui/button';
import { ShoppingBag, ArrowLeft } from 'lucide-react';

export default function OrdersDisabled() {
  return (
    <div className="min-h-screen bg-cream flex flex-col">
      <Navbar />
      
      <main className="flex-1 flex items-center justify-center px-4 py-16">
        <div className="max-w-md text-center">
          <div className="w-20 h-20 bg-garden-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <ShoppingBag size={40} className="text-garden-600" />
          </div>
          
          <h1 className="text-3xl font-heading font-bold text-garden-800 mb-4">
            Commande en ligne indisponible
          </h1>
          
          <p className="text-charcoal/70 mb-8">
            La commande en ligne n'est pas disponible pour le moment. 
            Vous pouvez consulter notre carte et nous rendre visite directement au restaurant.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/carte">
              <Button className="bg-garden-800 hover:bg-garden-900 text-white rounded-full px-6 py-3">
                Voir la carte
              </Button>
            </Link>
            <Link to="/">
              <Button variant="outline" className="border-garden-800 text-garden-800 hover:bg-garden-100 rounded-full px-6 py-3">
                <ArrowLeft size={16} className="mr-2" /> Retour à l'accueil
              </Button>
            </Link>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
}
